export default "__VITE_ASSET__F5N_jsCl__"